export const URL_BASE = 'https://areaprivada-dev.enpreproduccion.com/api/v1/'
